module.exports = __webpack_public_path__ + "static/media/до.93b9cb94.mp3";